import { lazy as lazyMfe, SuspenseWithErrorBoundary } from '@signavio/mfe'
import { useSession } from '@signavio/effektif-api'
import { useTheme } from '@signavio/ui'
import { GlobalHeaderFallback } from './GlobalHeaderFallback'
import { GlobalHeaderLoggedIn } from './GlobalHeaderLoggedIn'
import { HeaderPropsApi as GlobalHeaderProps } from 'global-mfe/types/header'

const HeaderModule = lazyMfe<GlobalHeaderProps>(
  () => import('GlobalHeader/Header')
)

export const GlobalHeader = () => {
  const session = useSession()
  const { logo } = useTheme()

  const isLoggedIn = session.sessionState === 'loggedIn'

  if (isLoggedIn) {
    return <GlobalHeaderLoggedIn />
  }

  return (
    <SuspenseWithErrorBoundary fallback={<GlobalHeaderFallback />}>
      <div className={'headerContainer'}>
        <HeaderModule
          appCode={'processGovernance'}
          logoSrc={logo}
          searchOptions={{
            visible: false,
          }}
          notificationOptions={{
            visible: false,
          }}
          disableAuthenticatedServices
          createOptions={{
            visible: false,
          }}
          userMenuOptions={{
            visible: false,
          }}
          helpMenuOptions={{
            visible: false,
          }}
          pxOptions={{
            visible: false,
          }}
        />
      </div>
    </SuspenseWithErrorBoundary>
  )
}
